"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasConsentQuery = void 0;
const activities_1 = require("../../../api/activities");
const useHasTopicQuery_1 = require("./useHasTopicQuery");
const useHasConsentQuery = (license, options) => (0, useHasTopicQuery_1.useHasTopicQuery)(activities_1.ActivityTopic.ConsentSoftwareAgreement, license, options);
exports.useHasConsentQuery = useHasConsentQuery;
